import { useRef, type ChangeEvent } from "react";
import classnames from "classnames";

import style from "./style.module.scss";
import themes from "../themes";
import { ImageContainer } from "../../../../media";
import { ArrowSelector, ColorPicker } from "../../../../ui";
import { useWidth } from "../../../../hooks";
import type { CalendarOptions, PhotoValue } from "../../../types";

interface CoverProps {
  productId?: string;
  userId?: string;
  options: CalendarOptions;
  setOptions: (options: Partial<CalendarOptions>) => void;
  isPreview?: boolean;
}

function Cover({ productId, userId, options, setOptions, isPreview }: CoverProps) {
  const selectedTheme = themes.find((theme) => theme.value === options.theme) || themes[0];
  const color = options.color ? options.color : selectedTheme ? selectedTheme.color : null;
  const onChangeTheme = (theme: string) => {
    setOptions({ theme });
  };
  const onChangeCoverPhoto = (photoUrl: PhotoValue) => {
    setOptions({ coverPhoto: photoUrl });
  };
  const coverContainer = useRef<HTMLDivElement>(null);
  const coverImage = useRef<HTMLDivElement>(null);
  const containerWidth = useWidth(coverContainer);
  const containerHeight = containerWidth ? containerWidth * 0.77 : undefined;
  const coverImageHeight = useWidth(coverImage);

  return (
    <div>
      {!isPreview && (
        <div className={style.formField}>
          <ArrowSelector
            options={themes}
            value={options.theme || themes[0].value}
            onChange={onChangeTheme}
            renderLabel={(label) => `Thème : ${label}`}
          />
        </div>
      )}

      {!isPreview && (
        <div className={classnames(style.formField, style.colorField)}>
          <ColorPicker value={color} onChange={(color) => setOptions({ color })} />
        </div>
      )}

      {!isPreview && (
        <div className={style.formField}>
          <label className={style.label}>Année :</label>
          <select
            value={options.year || 2026}
            onChange={(e: ChangeEvent<HTMLSelectElement>) =>
              setOptions({ year: parseInt(e.target.value) })
            }
            className={style.yearSelect}
          >
            {[2024, 2025, 2026, 2027, 2028, 2029, 2030].map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>
      )}

      <div
        ref={coverContainer}
        style={{
          height: containerHeight,
          backgroundColor: color ?? undefined,
          backgroundImage: `url("${selectedTheme.src}")`,
          fontSize: `${containerWidth}px`,
        }}
        className={style.coverContainer}
      >
        <div className={style.coverTitle}>Mon Calendrier {options.year || 2026}</div>
        <div
          ref={coverImage}
          style={{ height: coverImageHeight ?? undefined }}
          className={style.coverImage}
        >
          <ImageContainer
            image={options.coverPhoto}
            onChange={onChangeCoverPhoto}
            productId={productId}
            userId={userId}
            isPreview={isPreview}
            aspectRatio={1}
          />
        </div>
      </div>
    </div>
  );
}

export default Cover;
